'use strict';

const { h } = require('preact');

const Price = ({
  classes,
  option: {
    isUrgencyPricing,
    pricing: { formattedPrice },
  },
}) => {
  const priceClasses = classes.split(' ');

  priceClasses.push('breakout-option-price');

  if (isUrgencyPricing) {
    priceClasses.push('urgency-pricing', 'c-txt-err');
  } else {
    priceClasses.push('c-txt-price');
  }

  return h('div', {
    class: priceClasses.join(' '),
    dangerouslySetInnerHTML: {
      __html: formattedPrice,
    },
  });
};

module.exports = Price;
